import * as React from 'react';

import './styles.css';

export type Props = React.PropsWithChildren<{}>;

export const FullPage: React.StatelessComponent<Props> = (props) => {
  return (
    <div className="full-content">
      {props.children}
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/components/full-page/component.tsx